

import { Component, Vue, Watch } from 'vue-property-decorator'
import PublicTable from '@/components/PublicTable/PublicTable.vue'
import PublicTableView from '@/components/PublicTable/PublicTableView'
import { ICol } from '@/components/PublicTable/PublicTable'
import PublicQuery from '@/components/PublicQuery/PublicQuery.vue'
import { IFormItem } from '@/components/PublicQuery/PublicQuery'
import SelectRegion from '@/components/Select/SelectRegion.vue'
import SelectDepartment from '@/components/Select/SelectDepartment.vue'
import api from '../../api'
import { StatsUnitTypeMap } from '../../model/const'
import { UserModule } from '../../store/modules/user'
@Component({
  components: {
    PublicTable,
    PublicQuery,
    SelectRegion,
    SelectDepartment,
  },
})
export default class StatsTable extends PublicTableView {
  protected queryItems: IFormItem[] = [
    {
      label: '选择日期',
      key: 'date',
      type: 'date',
      dateType: 'daterange',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    },
    {
      label: '统计单位',
      key: 'level',
      type: 'select',
      options: Array.from(StatsUnitTypeMap).map(([value, label]) => {
        return {
          label, value,
        }
      }),
    },
  ]
  protected queryParams = {
    date: '',
    region: [],
    level: 0,
  }
  protected columns: ICol[] = [
    { label: '位置',
      prop: 'pathName',
    },
    { label: '总时长',
      prop: 'sumTime',
      children: [
        { label: '空调', prop: 'sum_air', sortable: true },
        { label: '灯光', prop: 'sum_switch', sortable: true },
        { label: '其他', prop: 'sum_other', sortable: true },
      ] },
    { label: '日平均时长',
      prop: 'avgTime',
      children: [
        { label: '空调', prop: 'avg_air', sortable: true },
        { label: '灯光', prop: 'avg_switch', sortable: true },
        { label: '其他', prop: 'avg_other', sortable: true },
      ] },
    { label: '数量',
      prop: 'devCount',
      children: [
        { label: '空调', prop: 'dev_air', sortable: true },
        { label: '灯光', prop: 'dev_switch', sortable: true },
        { label: '其他', prop: 'dev_other', sortable: true },
      ] },
    { label: '占比',
      prop: 'percent',
      children: [
        { label: '空调', prop: 'per_air', sortable: true },
        { label: '灯光', prop: 'per_switch', sortable: true },
        { label: '其他', prop: 'per_other', sortable: true },
      ] },
  ]
  @Watch('queryParams.level')
  private watchLevel() {
    this.queryParams.region = []
  }
  private handleSearch() {
    const { date = [], region = [], level = 0 } = this.queryParams || {}
    if (!date || !date.length) {
      this.$message.warning('请选择日期')
      return
    }

    if (!region || !region.length) {
      if (level === 3) {
        this.$message.warning('请选择统计部门')
      } else {
        this.$message.warning('请选择统计位置')
      }
      return
    }

    this.onQuery(1)
  }
  protected queryMethod = api.getRunTimeStatsTable
  protected getQueryParams(params: any) {
    const { date = [], region = [], level = 0 } = params || {}
    return {
      start: date[0],
      end: date[1],
      orgId: UserModule.orgInfo.orgId,
      level,
      posIds: level === 3 ? region : region.map((item: any) => item[item.length - 1]),
    }
  }
  protected processData(payload: any[]) {
    if (Array.isArray(payload)) {
      return payload.map((item: any) => {
        const { pathName = '', avgTime = {}, devCount = {}, percent = {}, sumTime = {} } = item || {}
        console.log('---------------' + JSON.stringify(item))
        return {
          pathName,
          avg_air: avgTime.air || '-',
          avg_switch: avgTime.switch || '-',
          avg_other: avgTime.other || '-',
          dev_air: devCount.air || '-',
          dev_switch: devCount.switch || '-',
          dev_other: devCount.other || '-',
          per_air: percent.air || '-',
          per_switch: percent.switch || '-',
          per_other: percent.other || '-',
          sum_air: sumTime.air || '-',
          sum_switch: sumTime.switch || '-',
          sum_other: sumTime.other || '-',
        }
      })
    } else {
      return []
    }
  }
}
